import React from "react";
import { useSelector } from "react-redux";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { actions as echeckActions } from "reducers/echecks";
import EndorseMultipleEchekSummaryBody from "./components/MultipleSummary";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";

const CancelEndorseSummaryPage = () => {
    const { echeqsEndorseData: endorseData, echeqsToDoActions: echeqAction } = useSelector((state) => state.echecks);
    const willCancel = endorseData?.endorseData?.cancelTransaction;
    const { echeckTicket } = useSelector((state) => state.echecks);
    const { dispatch } = useConfirmTransaction(endorseData, echeckTicket, "echecks/action/cancelendorse", true);

    return (
        <>
            <Notification scopeToShow="echecks/endorse/confirm" />
            <ResponsiveHeader id={"echecks.multiple.cancelEndorse"} />
            <MainContainer>
                <div className="container">
                    <h2>
                        <I18n id={willCancel ? "payments.cancel.title" :  "echecks.summary.endorse.confirm"} />
                    </h2>
                  
                    <EndorseMultipleEchekSummaryBody
                        beneficiary={
                          endorseData?.beneficiary
                        }
                        type={endorseData?.endorseData?.type}
                        reference={endorseData?.endorseData?.reference}
                        referencevalue={endorseData?.endorseData?.referencevalue}
                        echeqList={echeqAction?.echeqList}
                        cancelReason={echeqAction?.specialAttribute ?? endorseData?.endorseData?.reason}
                    />
                
                    <GeneralCredentialForm
                        hideIndications
                        transactionData={{ endorseData, echeqAction }}
                        action={willCancel ? echeckActions.cancelTransfer : echeckActions.cancelEndorseEcheq}
                        isCancel={willCancel}
                        idActivity={"cancel.endorse.echeq"}
                        disableContinueIfEmpty
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default CancelEndorseSummaryPage;
